export const isOnboarded = (company) => company?.status > 1

export const isTestCompany = (company) => company?.live !== true;

export const getBIRFilename = (company, reportYear) => `${company && `${typeof company === 'string' ? company : company.name ?? ''} `}Business Insights Report${reportYear ? ` ${reportYear}` : ''}.pdf`
